import { composeValidators } from '@alfa-bank/site-form-helpers/validation/utils';
import { validateBirthday } from '@alfa-bank/site-form-birthday/src/helpers';

// Проверяет возраст. Работать и открывать ИП можно с 14 лет
export const validateBirthdate = () =>
    composeValidators(validateBirthday('Некорректная дата', 14, undefined, true));
